
// export default function contains(root, n) {
//     let node = n;
//     while (node) {
//         if (node === root) {
//             return true;
//         }
//         node = node.parentNode;
//     }
//
//     return false;
// }

import contains from 'rc-util/lib/Dom/contains';

export default contains;
